import fetch from '@/utils/fetch';
import { message } from 'antd';
import filterNull from '@/utils/filterNull';
import { getTpShopList, ITpShopListParams } from './service';

const model = {
  state: {
    queryParams: {
      shop_name: '', // 店铺名称
      shop_id: '', // 店铺ID
      status: '', // 状态
      type: '', // 对接方
    },

    pagination: {
      cur_page: 1, // 当前页数
      per_page: 10, // 每页条数
    },
    total: 0, // 数据总数
    dataSource: [], // 数据列表
    listLoading: false,

    showCreateModal: false, // 控制新建店铺弹框显示与否
    confirmLoading: false,
    shop_name: '', // 新建店铺弹框中的店铺名称
    typeControl: 1,

    showUpdateModal: false, // 控制修改店铺信息弹框显示与否
    shopInfo: null,
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { customerAbutment }, getState }: any) => ({
    /**
     * 更新店铺弹框确定
     */
    async UpdateModelOnOk(params: any) {
      const data = await fetch('/merchant/tp/tpshopupdate', {
        type: 'POST',
        params,
      });
      if (data) {
        message.success('修改成功！');
        customerAbutment.UpdateModelOnCancel();
        customerAbutment.getList();
      }
    },
    /**
     * 更新店铺弹框确取消
     */
    UpdateModelOnCancel() {
      customerAbutment.setState({
        showUpdateModal: false,
      });
    },
    /**
     * 编辑店铺信息
     */
    showUpdate() {
      customerAbutment.setState({
        showUpdateModal: true,
      });
    },
    /**
     * 读取点击行数据
     * @param shopInfo 每一行的数据
     */
    setShopInfo(shopInfo: any) {
      customerAbutment.setState({
        shopInfo,
      });
    },
    deleteShopInfo(shopInfo: any) {
      customerAbutment.setState({
        shopInfo: null,
      });
    },
    /**
     * 添加店铺切换对接方控制显示对应商户号
     * @param value 选中的值
     */
    changeType(value: number) {
      customerAbutment.setState({
        typeControl: value,
      });
    },
    /**
     * 添加店铺
     */
    async addShop() {
      customerAbutment.setState({
        showCreateModal: true,
      });
    },
    /**
     * 新建店铺弹框确定
     */
    async createModelOnOk(params: any) {
      const data = await fetch('/merchant/tp/tpshopadd', {
        type: 'POST',
        params,
      });
      if (data) {
        customerAbutment.getList();
        message.success('添加成功！');
      }
      customerAbutment.setState({
        showCreateModal: false,
      });
    },
    /**
     * 新建店铺弹框确取消
     */
    createModelOnCancel() {
      customerAbutment.setState({
        showCreateModal: false,
      });
    },
    /**
     * 根据店铺ID获取店铺名称
     * @param shop_id 店铺ID
     */
    async getShopNameById(shop_id: number) {
      const data = await fetch('/merchant/tp/getshopinfobyid', {
        type: 'GET',
        useJson: true,
        params: filterNull({
          shop_id,
        }),
      });
      if (data) {
        customerAbutment.setState({
          shop_name: data.shop_name,
        });
        return data.shop_name;
      }
      return '';
    },
    /**
     * 赋值查询参数
     * @param values: 查询匹配值
     */
    onSearch(values: any) {
      customerAbutment.setState({
        queryParams: {
          shop_name: values.shop_name,
          shop_id: values.shop_id,
          status: values.status,
          type: values.type,
        },
      });
      customerAbutment.getList();
    },
    /**
     * 分页功能函数
     * @param cur_page: 当前页码
     * @param per_page: 每页数据条数
     */
    onPageChange(cur_page: number, per_page: number) {
      customerAbutment.setState({
        pagination: {
          cur_page,
          per_page,
        },
      });
      customerAbutment.getList();
    },
    /**
     * 获取数据函数
     */
    async getList() {
      const { queryParams, pagination } = getState().customerAbutment;
      customerAbutment.setState({ listLoading: true });
      const params = filterNull({
        ...queryParams,
        page: pagination.cur_page,
        pageSize: pagination.per_page,
        sub_shop_id: queryParams.shop_id, //php-->java接口迁移，shop_id变成了sub_shop_id
      });
      const data = await getTpShopList(params as ITpShopListParams);
      customerAbutment.setState({ listLoading: false });
      if (data) {
        customerAbutment.setState({
          dataSource: data.list,
          total: data.total,
        });
      }
    },
    async setTpShopStatus(params: any) {
      const data = await fetch('/merchant/tp/settpshopstatus', {
        type: 'POST',
        params,
      });
      if (data) {
        customerAbutment.getList();
        message.success('修改成功！');
      }
    },
  }),
};

export default model;
